import React, {Component, Fragment} from 'react';
import OptPackage from './Options/OptionPackage';
import ReactHtmlParser from "react-html-parser";
import OptFeature from "./Options/OptionFeature";

class ОptionalPackages extends Component {

    state = {
        isPlanCollapsed: false
    };

    collapsePlan = () => {
        this.setState((prevProps) => ({
            isPlanCollapsed: !prevProps.isPlanCollapsed
        }));
    };

    render() {
        const { isPlanCollapsed } = this.state;
        const { features, lineIndex, planFeature, handleOptionalPackagesCheckbox } = this.props;

        return (
            <div className={'product-item' + (isPlanCollapsed ? ' product-item-collapsed' : '')}>

                <div className="header">

                    <div className="header-title">Optional Packages</div>

                    <button className="btn header-collapse" type="button" onClick={() => this.collapsePlan()}>
                        <i className="fas fa-angle-up"></i>
                    </button>

                </div>

                <div className="details">

                    <div className="description">
                        {planFeature.map((featurePackage) => (
                            <Fragment key={featurePackage.featurePackageId}>
                                <hr/>
                                <h5>
                                    {featurePackage.name}
                                </h5>

                                {featurePackage.featurePackageOptions.map((packageOption) => (
                                    <OptPackage
                                        packageOption={packageOption}
                                        featurePackage={featurePackage}
                                        key={packageOption.featurePackageOptionId}
                                        {...this.props}
                                    />
                                ))}
                            </Fragment>
                        ))}
                    </div>

                </div>

            </div>
        );
    }
}

export default ОptionalPackages;
